import { Alert } from '@agentnet/components';
import { Party } from 'api/file/interfaces/get-file-order-insights';
import clsx from 'clsx';
import HourglassTopOutlined from 'ui-kit/icons/HourglassTopOutlined';
import { theme } from 'ui-kit/theme/theme';
import { getVerificationExpiryTime } from 'utilities/dateFormatter';
import ContactInfoDisplay from './ContactInfoDisplay';
import OrderInsightsRiskIcon from './OrderInsightsRiskIcon';
import useStyles from './PdfListStyles';
import VerificationResults from './VerificationResults';

interface IEnabledPdfProducts {
  type: 'ContactValidation' | 'EnhancedIdentityVerification';
  party: Party;
}

const EnabledPdfProducts = ({ type = 'ContactValidation', party }: IEnabledPdfProducts) => {
  const classes = useStyles();

  const isContactValidation = type === 'ContactValidation';

  const hideEditParty = {
    ContactValidation: !!party.phoneNumber || !!party.emailAddress,
    EnhancedIdentityVerification: !!party.phoneNumber,
  };

  if (hideEditParty[type]) {
    if (isContactValidation && party.contactValidation) {
      const contactInfo = party.contactValidation;
      return <ContactInfoDisplay {...contactInfo} isPdf />;
    }

    const identityResults = party.enhancedIdentifyVerification;
    if (identityResults && !isContactValidation) {
      return identityResults?.transactionStatus === 'Completed' ? (
        <VerificationResults {...identityResults} isPdf />
      ) : identityResults?.transactionStatus === 'Pending' ? (
        <Alert severity="warning" icon={<HourglassTopOutlined fill={theme.palette.status.pending} />}>
          <strong>Pending Response from Party</strong> <br /> <strong>Request Submitted:</strong>{' '}
          {getVerificationExpiryTime(identityResults.submitted ?? '')}
        </Alert>
      ) : (
        <>
          {identityResults?.transactionStatus === 'Failed' && (
            <Alert
              className={clsx(classes.infoAlert, classes.typographyFontSize)}
              severity={'info'}
              icon={<OrderInsightsRiskIcon riskSeverity="Error" isPdf />}
            >
              {'Party failed to complete identity verification'}
            </Alert>
          )}
        </>
      );
    }
  }

  return (
    <Alert
      className={clsx(classes.infoAlert, classes.typographyFontSize)}
      severity={'info'}
      icon={<OrderInsightsRiskIcon riskSeverity={'None'} isPdf />}
    >
      {'Not requested for the party'}
    </Alert>
  );
};

export default EnabledPdfProducts;
